import React from "react";

import { Card } from "../../ui/card";
import { BUCKET_ORDER, getStakeholderLaneAppearance } from "../config/stakeholderLaneConfig";
import StakeholderBucketSection from "./StakeholderBucketSection";
import StakeholderLaneHeader from "./StakeholderLaneHeader";

export default function StakeholderLaneColumn({ lane, onOpen, onOpenLane }) {
  const appearance = getStakeholderLaneAppearance(lane.id);
  return (
    <Card
      className={`flex shrink-0 flex-col gap-4 rounded-[28px] border p-4 shadow-[0_24px_50px_-28px_rgba(15,23,42,0.45)] ${appearance.shellClass} ${lane.widthClass}`}
    >
      <StakeholderLaneHeader lane={lane} onOpenLane={onOpenLane} />

      <div className="space-y-4">
        {BUCKET_ORDER.map((bucket) => (
          <StakeholderBucketSection bucket={bucket} items={lane.items[bucket]} key={bucket} onOpen={onOpen} />
        ))}
      </div>
    </Card>
  );
}
